export default "__VITE_ASSET__BpMOjeVf__"